import React, { ReactNode } from "react";

export type FormFieldDisplayProps<T = unknown> = {
  children?: ReactNode;
  value?: T;
  format?: (value?: T | null) => ReactNode;
};

/**
 * Se comporta como um campo de formulário dentro de um `<Form.Item />` ou `<StepsFormField />`
 * Apenas formata e renderiza o valor do campo
 */
export function FormFieldDisplay<T = unknown>(props: FormFieldDisplayProps<T>) {
  const { children = <div />, value, format, ...inputProps } = props;
  const display = (format ? format(value) : (value as ReactNode)) || "-";

  const child = React.Children.only(children);
  if (!React.isValidElement(child)) return display;

  return React.cloneElement(child, inputProps, display);
}
